import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-relay/src/__generated__/profileMenuQuery$parameters';
import { fg } from '@atlassian/jira-feature-gating';

export const Nav4ProfileMenuEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "atlassian-navigation-profile-menu" */ './src/ui/profile-menu'),
	),
	getPreloadProps: ({ atlassianAccountId }: { atlassianAccountId?: string }) => ({
		queries: {
			profileMenuQuery: {
				parameters,
				variables: {
					atlassianAccountId: atlassianAccountId ?? '',
					newNav4ProfileQueryEnabled: fg('blu-7584-replace-nav4-profile-query'),
				},
			},
		},
	}),
});
